import CompareTwoPasswords, { ITwoPasswordsValidatorResult } from "./CompareTwoPasswords";
import EmailValidator, { IEmailValidatorResult } from "./EmailValidator";
import { IsStringNotEmptyValidator, ValidationResult } from "./IsStringNotEmptyValidator";
import MobilePhoneValidator, { IMobilePhoneValidatorResult } from "./MobilePhoneValidator";
import PasswordValidator, { IPasswordValidatorResult } from "./PasswordValidator";

export default {
    CompareTwoPasswords,
    EmailValidator,
    IsStringNotEmptyValidator,
    MobilePhoneValidator,
    PasswordValidator,
};

export type { ITwoPasswordsValidatorResult, IEmailValidatorResult, ValidationResult, IMobilePhoneValidatorResult, IPasswordValidatorResult };
